// extracted by mini-css-extract-plugin
export default {"seriesCards":"eY0ZgkSyvS3R6XcRxDLg","seriesRow":"ygMh_CZvr6wsgl2oSFxA"};